import React, { useEffect, useState } from 'react';
// import url from "../../constants/urlList";

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// Legitimate popup callers open /socialAuth via
// window.open(oauthUrl, "Sign In", …) — exam-review-drawer's in-context
// re-auth (and the login page's pre-E3 flow) — so a genuine popup of ours
// always carries this window.name. The same-tab redirect flow sets no name.
const POPUP_WINDOW_NAME = 'Sign In';

// Google OAuth landing (/socialAuth?token=…). Two entry modes:
//   1. Popup (backward-compatible): opened by a caller that still uses
//      window.open — exam-review-drawer's in-context re-auth. Hand the token
//      back via postMessage and close.
//   2. Same-tab redirect (E3): the login page navigates the whole tab to the
//      provider, so there is no popup context on return. Stash the token + a
//      pending flag and bounce to /login, which finishes the sign-in through
//      its existing, tested resolution + error surfaces.
//
// SECURITY (gate B1): the popup branch is taken ONLY for windows we opened
// ourselves. A bare `window.opener` check is not enough — if a foreign page
// window.open()'d an app URL, `opener` persists across the entire same-tab
// OAuth redirect chain, and posting the JWT to it with a '*' targetOrigin
// would hand the session token to an arbitrary origin and window.close() the
// user's sign-in. So: (a) require our known popup window.name in addition to
// an opener, and (b) lock postMessage's targetOrigin to our own origin —
// never '*' (the only legitimate consumer is same-origin; a cross-origin
// opener never receives the message even if it spoofs the name). Any other
// context takes the same-tab branch, which keeps the token in our
// localStorage only and completes the sign-in instead of killing the tab.
export const AuthRedirect = () => {
    const [error, setError] = useState(false);

    useEffect(() => {
        const token = getParameterByName('token');

        if (window.opener && window.name === POPUP_WINDOW_NAME) {
            try {
                window.opener.postMessage(
                    { msg: "Login Successful", results: { accessToken: token } },
                    window.location.origin);
                setTimeout(() => { window.close(); }, 300);
            } catch (err) {
                setError(true);
            }
            return;
        }

        if (token) {
            window.localStorage.setItem('token', token);
            window.localStorage.setItem('oauthPending', 'true');
            window.location.replace('/login');
        } else {
            setError(true);
        }
    }, []);

    if (error) {
        return (<div>UnAuthorized User</div>);
    }
    return (<></>);
}
